/**
 * THE AVATAR'S HUE — W81 (pro web step 7): a person without a photo is drawn as their initials on a colour that is
 * THEIRS, the same on every page and every visit, so a coach learns a client's colour the way they learn a face.
 *
 * ⚠️ PURE AND STABLE, AND THAT IS THE WHOLE CONTRACT: the hue is a function of the NAME alone — no index, no position in
 * a list, no random, no date — so the roster, the Dashboard's queue, the review head and the Inbox agree without talking
 * to each other, and a reload never repaints anybody. The name is normalised first (trimmed, inner whitespace collapsed,
 * lower-cased) so `Dana Sample` and ` dana  sample ` are one person's colour.
 *
 * ⚠️ IT RETURNS A HUE, NEVER A COLOUR. The colour is `pro.css`'s (`.ht-avatar`: an oklch gradient at fixed lightness, so
 * white initials clear 4.5:1 on every hue) — this file states no colour, and no page paints one.
 *
 * FNV-1a (32-bit) over the UTF-16 code units, folded to 0–359. Chosen for being tiny, dependency-free and well spread on
 * short strings; nothing here is a security property.
 */
export function avatarHue(name: string): number {
  const key = name.trim().replace(/\s+/g, " ").toLowerCase();
  let h = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h % 360;
}
